import { TenantId } from '../enums/TenantId';

// Mapping of tenant IDs to IDP names for SSO
export const tenantToIDP: Record<string, string> = {
  [TenantId.BRANDEIS]: 'Brandeis',
  [TenantId.BRANDEIS_MOCK]: 'Brandeis-Mock',
  [TenantId.CSU]: 'CSU',
  [TenantId.CSU_MOCK]: 'CSU-Mock',
  [TenantId.AU]: 'AmericanUniversity',
  [TenantId.AU_MOCK]: 'AmericanUniversity-Mock',
};

// Mapping of route paths to full tenant IDs
export const routeToTenantId: { [key: string]: string } = {
  'brandeis': TenantId.BRANDEIS,
  'brandeis-mock': TenantId.BRANDEIS_MOCK,
  'csu': TenantId.CSU,
  'csu-mock': TenantId.CSU_MOCK,
  'au': TenantId.AU,
  'au-mock': TenantId.AU_MOCK,
};

// Reverse mapping: tenant IDs to route paths (for logout redirects)
export const tenantIdToRoute: { [key: string]: string } = {
  [TenantId.BRANDEIS]: 'brandeis',
  [TenantId.BRANDEIS_MOCK]: 'brandeis-mock',
  [TenantId.CSU]: 'csu',
  [TenantId.CSU_MOCK]: 'csu-mock',
  [TenantId.AU]: 'au',
  [TenantId.AU_MOCK]: 'au-mock',
};
